import SendIcon from '../../../../../assets/send.svg';
import { useChatContext } from '../../../../../contexts/ChatContext';
import { fetchContact } from '../../../../../utils/fetchContact';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { getChatSession } from '../../../../../utils/getChatSession';
import { $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import { $getRoot } from 'lexical';
import { Button } from '@coolblue-development/freddy';

const SendButton = (): JSX.Element => {
  const { selectedChat } = useChatContext();
  const [editor] = useLexicalComposerContext();

  const sendMessage = async (): Promise<void> => {
    if (!selectedChat) return;

    const contact = fetchContact(selectedChat);
    if (!contact) return;

    const chatSession = await getChatSession(contact);
    if (!chatSession) return;

    editor.read(() => {
      const message = $convertToMarkdownString(TRANSFORMERS);
      void chatSession.sendMessage({
        contentType: 'text/markdown',
        message: message
      });
    });

    editor.update(() => $getRoot().clear());
  };

  return (
    <Button
      endIcon={<SendIcon />}
      variant="primary"
      data-testid="send-button"
      size="small"
      onClick={sendMessage}
      sx={{ width: '40px', padding: '0px' }}
    />
  );
};

export default SendButton;
